// extracted by mini-css-extract-plugin
module.exports = {"developer":"_93444fe79c--developer--c7T1h","logo":"_93444fe79c--logo--qzXmO","data":"_93444fe79c--data--AH_yF"};